import { ListLocationModel } from "client/Api/Documents/SharePoint/common";
import * as DocumentStoreType from "client/Api/Documents/common";
import { environmentHttpClient as httpClient } from "client/Api/httpClient";

const controllerRelativeUrl: string = "Documents/CrossStoreActions";

type CancelAcrossDataStoresModel = {
	masterJobId: string;
};

export type MoveAcrossDataStoresModel = {
	items: CrossStoreItems;
	destination: CrossStoreDestination;
};

export type CopyAcrossDataStoresModel = {
	items: CrossStoreItems;
	destination: CrossStoreDestination;
	newName: string | null;
};

export type CrossStoreOperationErrorModel = {
	itemName: string;
	path: string;
	reason: string;
	isFolder: boolean;
	isOneNoteNotebook: boolean;
};

type CrossStoreItems = SharePointCrossStoreItems | WebDavCrossStoreItems;

type SharePointCrossStoreItems = {
	storeType: DocumentStoreType.DocumentStoreType.SharePoint;
	sharePointItems: SharePointCrossStoreItemModel[];
};

export type SharePointCrossStoreItemModel = {
	id: number;
	location: ListLocationModel;
};

type WebDavCrossStoreItems = {
	storeType: DocumentStoreType.DocumentStoreType.WebDav;
	webDavItems: WebDavCrossStoreItemModel[];
};

export type WebDavCrossStoreItemModel = {
	id: string;
	serverId: number;
};

export type CrossStoreDestination = SharePointCrossStoreDestination | WebDavCrossStoreDestination;

export type SharePointDestinationModel = {
	folderId: number | null;
	location: ListLocationModel;
};

type SharePointCrossStoreDestination = {
	storeType: DocumentStoreType.DocumentStoreType.SharePoint;
	name: string;
	sharepoint: SharePointDestinationModel;
};

export type WebDavDestinationModel = {
	folderId: string;
	serverId: number;
};

type WebDavCrossStoreDestination = {
	storeType: DocumentStoreType.DocumentStoreType.WebDav;
	name: string;
	webdav: WebDavDestinationModel;
};

export function move(
	data: MoveAcrossDataStoresModel,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.post<void>(
		controllerRelativeUrl + "/Move",
		data,
		{ signal }
	);
}

export function copy(
	data: CopyAcrossDataStoresModel,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.post<void>(
		controllerRelativeUrl + "/Copy",
		data,
		{ signal }
	);
}

export function cancelJob(masterJobId: string): Promise<void> {
	const data: CancelAcrossDataStoresModel = {
		masterJobId: masterJobId
	};

	return httpClient.post<void>(controllerRelativeUrl + "/Cancel", data);
}

export function retrieveErrors(
	masterJobId: string,
	signal?: AbortSignal
): Promise<readonly CrossStoreOperationErrorModel[]> {
	return httpClient.get<readonly CrossStoreOperationErrorModel[]>(
		`${controllerRelativeUrl}/Errors/${encodeURIComponent(masterJobId)}`,
		undefined,
		{ signal }
	);
}